/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailValidationRequest
 */
export interface EmailValidationRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailValidationRequest
     */
    validationCode: string;
}

/**
 * Check if a given object implements the EmailValidationRequest interface.
 */
export function instanceOfEmailValidationRequest(value: object): value is EmailValidationRequest {
    if (!('validationCode' in value) || value['validationCode'] === undefined) return false;
    return true;
}

export function EmailValidationRequestFromJSON(json: any): EmailValidationRequest {
    return EmailValidationRequestFromJSONTyped(json, false);
}

export function EmailValidationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailValidationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'validationCode': json['validationCode'],
    };
}

export function EmailValidationRequestToJSON(value?: EmailValidationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'validationCode': value['validationCode'],
    };
}

